import React from "react";

const IconCard = ({ icon, changeIcon }) => {
  return (
    <>
      <span
        onClick={() =>
          changeIcon(`https://assessn.mmaviot.com${icon.filename}`)
        }
        className="changeWidgetIcons cursor bg-white 
                mx-1 mb-3 cursor text-center rounded-circle d-block"
      >
        <img
          src={`https://assessn.mmaviot.com${icon.filename}`}
          width="20"
          height="20"
        />
      </span>
    </>
  );
};

export { IconCard };
